import PropTypes from 'prop-types'
import React from 'react'
import Tooltip from 'react-tooltip'
import Icon from './Icon'

export default function StateIcon({ item }) {

  let name = 'ok-color'
  let tooltip = 'Online.'

  if (item.isRejected) {
    name = 'cancel-color'
    tooltip = 'Vom Administrator abgelehnt. Benötigt Überarbeitung.'
  }
  else if (item.isDirty) {
    name = 'user-admin'
    tooltip = 'Liegt beim Administrator zur Prüfung.'
  }

  return (
    <span>
      <span data-tip={tooltip}>
        <Icon
          size={18}
          name={name}
        />
      </span>
      <Tooltip
        className={`tooltip ${name}`}
        // multiline
        html
        place="top"
        type="info"
      // effect="solid"
      />
    </span>
  )
}

StateIcon.propTypes = {
  item: PropTypes.shape({
    isDirty: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
    ]),
    needsReview: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.bool,
    ])
  })
}



// WEBPACK FOOTER //
// ./src/shared/components/StateIcon.js